export enum actionTypes {
    HIDE_FOOTER = 'FOOTER:HIDE_FOOTER',
    SHOW_FOOTER = 'FOOTER:SHOW_FOOTER'
}
